import { useQuery } from "react-query";
import {
  getEmploymentType,
  getEmploymentTypeFilter,
} from "../../../../../actions/Utilities/EmploymentType";

export const useEmploymentType = () => {
  const { data } = useQuery("GetEmploymentType", getEmploymentType, {
    refetchOnWindowFocus: false,
  });
  return data;
};

export const useEmploymentTypeFilter = () => {
  return useQuery("GetEmploymentTypeFilter", getEmploymentTypeFilter, {
    refetchOnWindowFocus: false,
  });
};
